import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environment/environment';
import { enableProdMode } from '@angular/core';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));

if (environment.production) {
  window.console.log = function () { };
  enableProdMode();
}

